import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PriceTagSVG = function PriceTagSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28.001 2h-10a1.966 1.966 0 00-1.41.59l-14 14a1.974 1.974 0 000 2.82l10 10a1.98 1.98 0 002.82 0l14-14a1.966 1.966 0 00.59-1.41V4a2.006 2.006 0 00-2-2zm-4 8a2 2 0 11-2-2 2.006 2.006 0 012 2zm-12.94 10.54a1.054 1.054 0 01-.06-.33.54.54 0 01.61-.56.636.636 0 01.62.43 2.126 2.126 0 002.05 1c.88-.06 1.41-.5 1.41-1.18 0-.63-.38-.96-1.4-1.22l-1.01-.24c-1.54-.36-2.25-1.06-2.25-2.21a2.312 2.312 0 012.14-2.27v-.29a.645.645 0 111.29 0v.26a2.537 2.537 0 012.29 1.59 1.393 1.393 0 01.05.32c0 .31-.22.5-.58.5a.71.71 0 01-.65-.42 1.996 1.996 0 00-1.89-.99c-.79.09-1.33.52-1.33 1.14 0 .59.4.95 1.29 1.19l1.04.24c1.63.38 2.32 1.04 2.32 2.21 0 1.56-1.27 2.24-2.53 2.37v.26a.645.645 0 11-1.29 0v-.29a2.475 2.475 0 01-2.12-1.51z"
  }));
};
PriceTagSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PriceTagSVG);